import { IDeleteColetaProdutoServicoUseCase } from "../../../presentation/useCases/delete/delete_coleta_produto_servico_use_case";
import { IComprasRepository } from "../../repositories/compras_repositories";

/**
 * DeleteColetaProdutoServicoUseCase
 */

export class DeleteColetaProdutoServicoUseCase implements IDeleteColetaProdutoServicoUseCase {
  constructor(private readonly repository: IComprasRepository) { }

  async deleteColetaProdutoServico(
    idColetaPreco: number,
    idColetaProdutoServico: number,
  ): Promise<void> {
    await this.repository.deleteColetaProdutoServico(idColetaPreco, idColetaProdutoServico);
  }
}
